module.exports = __webpack_public_path__ + "static/media/phone_icon.7a85c613.svg";